import fecha from "fecha";
import { FULL_FORMAT } from "./constants.js";
import locales from "./locales/index.js";
const toDate = (str, fmt = FULL_FORMAT, lang = 'es')=>{
    fecha.i18n = locales[lang];
    const parsedDate = fecha.parse(str, fmt);
    return parsedDate instanceof Date ? parsedDate : void 0;
};
const date_toDate = toDate;
export default date_toDate;
